var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.44453C0 5.59708 0 4.17335 0.562933 3.08966C1.03731 2.17644 1.78191 1.43184 2.69513 0.957464C3.77882 0.394531 5.20255 0.394531 8.05 0.394531H15.95C18.7975 0.394531 20.2212 0.394531 21.3049 0.957464C22.2181 1.43184 22.9627 2.17644 23.4371 3.08966C24 4.17335 24 5.59708 24 8.44453V16.3445C24 19.192 24 20.6157 23.4371 21.6994C22.9627 22.6126 22.2181 23.3572 21.3049 23.8316C20.2212 24.3945 18.7975 24.3945 15.95 24.3945H8.05C5.20255 24.3945 3.77882 24.3945 2.69513 23.8316C1.78191 23.3572 1.03731 22.6126 0.562933 21.6994C0 20.6157 0 19.192 0 16.3445V8.44453Z",
    fill: "url(#paint0_linear_939_5860)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 15.7272L17.2 12.3939H14V10.0605C14 9.12721 14.3333 8.39388 15.8 8.39388H17.3333V5.32721C16.4667 5.19388 15.5333 5.06055 14.6667 5.06055C11.9333 5.06055 10 6.72721 10 9.72721V12.3939H7V15.7272H10V24.3939C11.3333 24.3939 12.6667 24.3939 14 24.3939V15.7272H16.6667Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_939_5860",
    x1: 12,
    y1: 23.6933,
    x2: 12,
    y2: 0.394531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.02a13fed0a4dfddac4127d6b0c70cdc2.svg";
export { ForwardRef as ReactComponent };